import React from 'react'
import ReactDOM from 'react-dom'

import LoadStyles from '@driftt/tide-core/dist/styles'

import ConnectedApp, { injectReducers }  from '@driftt/traffic-control'
import { SegmentBuilderRootReducer } from '@driftt/cyberno'
import { rootReducer } from 'modules'
import config from 'config'

import App from './layouts/App'

import './index.css'

injectReducers(SegmentBuilderRootReducer)
LoadStyles()

ReactDOM.render(
	<ConnectedApp reducers={rootReducer} render={() => <App />} authClientId={config.AUTH_CLIENT_ID} />
, document.getElementById('root'))


window.noop = () => {}
